<h1>Impressum</h1>
<section class="article">
  <article>
    <img src="assets/isb_logo.jpg" />
    <h3>© 2019 ISB Information und Kommunikation GmbH & Co. KG</h3>

    <h3>Sitz: 33142 Büren, Lindberghring 6a</h3>

    <h3>
      Tel.: +49 2955 74722 0<br />
      Fax: +49 2955 74722 67
    </h3>

    <h3>E-Mail: info@isb-ik.de</h3>

    <h3>
      Registergericht Paderborn HRA 5032<br />
      Vertreten durch Dipl.-Ing. Steffen Buhr
    </h3>

    <h3>
      Komplementärin: Buhr GmbH<br />
      Sitz: Büren<br />
      Registergericht Paderborn HRB 7904
    </h3>

    <h3>USt.-ID: DE814614297</h3>

    <h3>
      Verantwortlich im Sinne des Presserechts ist Dipl.-Ing. Steffen Buhr.
    </h3>
    <div class="text">
      Technische Fragen im Zusammenhang mit dieser Website oder unseren
      Softwareprodukten beantworten wir Ihnen gerne unter
      <a class="mail" href="mailto:support@isb-ik.de">support@isb-ik.de</a>.
      Bitte beachten Sie dazu auch unsere Informationen unter
      <a
        href="https://isb-ik.de/home/kontakt/service-wartungszeiten.aspx"
        target="_blank"
        >Service-/Wartungszeiten</a
      >.
    </div>
    <div class="text">
      Sofern Sie Fragen zum Datenschutz haben, können Sie diese vertrauensvoll
      an
      <a class="mail" href="mailto:datenschutz@isb-ik.de"
        >datenschutz@isb-ik.de</a
      >
      senden.
    </div>
    <div class="text">
      <p>
        Alle verwendeten Texte, Grafiken, Produkt- und Firmenbezeichnungen bzw.
        -namen unterliegen, soweit nicht ausdrücklich anders vermerkt, dem
        Copyright der jeweiligen Hersteller oder der ISB Information und
        Kommunikation GmbH & Co. KG (nachfolgend "ISB" genannt) und dürfen ohne
        Zustimmung weder vervielfältigt noch außerhalb dieses Internet-Auftritts
        verwendet werden.
      </p>
      <p>
        Die Nennung von Firmenbezeichnungen, Marken- und Handelsnamen sowie
        Marken- und Warenzeichen erfolgt ausschließlich zu Informations-
        und/oder Erklärungszwecken. ISB erhebt in keiner Weise Ansprüche auf die
        Rechte an Markennamen und Warenzeichen Dritter. Alle Rechte an Marken,
        Markennamen, Warenzeichen und Trademarks liegen bei den jeweiligen
        Rechteinhabern. Allein aufgrund der bloßen Nennung ist nicht der Schluss
        zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind.
      </p>
      <p>
        ISB bemüht sich um die ständige Aktualisierung dieser Website, übernimmt
        jedoch keine Garantie für die Richtigkeit und Vollständigkeit des
        Inhalts. Mit Ausnahme von unmittelbaren Schäden, die durch ISB
        vorsätzlich oder grob fahrlässig herbeigeführt worden sind, übernimmt
        ISB keine Haftung.<br />
        Dies gilt insbesondere für Folgeschäden oder sonstige
        Strafschadenersatzansprüche, die sich aus oder im Zusammenhang mit
        dieser Website ergeben, wie z. B. entgangener Gewinn, Störungen des
        Geschäftsablaufs und Verlust elektronischer Daten.
      </p>
      <p>
        Wir sind zur Teilnahme an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle bereit.
      </p>
      <p>
        Die zuständige Verbraucherschlichtungsstelle ist: Allgemeine
        Verbraucherschlichtungsstelle des Zentrums für Schlichtung e.V.<br />Straßburger
        Straße 8<br />77694 Kehl am Rhein
      </p>
      <p>
        <a href="https://www.verbraucher-schlichter.de"
          >www.verbraucher-schlichter.de</a
        >
      </p>
    </div>
  </article>
</section>
